"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traverse = traverse;
exports.findJSONFunctionCalls = findJSONFunctionCalls;
exports.findAstFunctionCalls = findAstFunctionCalls;
exports.getFieldFunctionAstMatches = getFieldFunctionAstMatches;
exports.getFieldFunctionAstMatch = getFieldFunctionAstMatch;
exports.replaceInString = replaceInString;
const lodash_1 = require("lodash");
const acorn_1 = require("acorn");
const types_1 = require("./types.js");
/**
 * @description Traverses a tree returning with nodes and their paths where the callback function returns true
 * @param node
 * @param callback
 * @param path
 * @param collection
 */
function traverse(node = {}, callback = () => false, path = [], collection = []) {
    const conditionMet = callback(node);
    if (conditionMet)
        collection.push({ path: [...path], node });
    if (Array.isArray(node)) {
        for (const key in node) {
            path.push(key);
            traverse(node[key], callback, path, collection);
            path.pop();
        }
    }
    else if ((0, lodash_1.isPlainObject)(node)) {
        for (const key of Object.keys(node)) {
            path.push(key);
            traverse(node[key], callback, path, collection);
            path.pop();
        }
    }
    return collection;
}
function extractCallExpressionInfo(expression) {
    if (expression.type !== 'CallExpression')
        return null;
    const callExpr = expression;
    const callee = callExpr.callee;
    const args = callExpr.arguments;
    if (callee.type !== 'Identifier')
        return null;
    const functionName = callee.name;
    const argumentValues = args.map(arg => (arg.type === 'Literal' ? arg.value : null));
    return { functionName, functionArguments: argumentValues };
}
function findJSONFunctionCalls(json) {
    const functionReferences = [];
    const fieldReferenceNodes = traverse(json, (node) => typeof node === 'string');
    for (const reference of fieldReferenceNodes) {
        if (types_1.OPERATORS.includes(reference.node.trim())) {
            continue;
        }
        const expAst = (0, acorn_1.parse)(reference.node, { ecmaVersion: 2023 });
        const functionCalls = expAst.body.filter(node => node.type === types_1.ACORN_AST_TYPES.EXPRESSION_STATEMENT);
        for (const { expression } of functionCalls) {
            const functionReference = extractCallExpressionInfo(expression);
            if (functionReference !== null)
                functionReferences.push({ path: reference.path, ...functionReference });
        }
    }
    return functionReferences;
}
function findAstFunctionCalls(astExpression) {
    let ast = [];
    const functionReferences = [];
    try {
        ast = JSON.parse(astExpression);
    }
    catch (error) {
        return [];
    }
    const fieldReferenceNodes = traverse(ast, (node) => node?.type === 'expression');
    for (const { node } of fieldReferenceNodes) {
        const expAst = (0, acorn_1.parse)(node.value, { ecmaVersion: 2023 });
        const functionCalls = expAst.body.filter(node => node.type === types_1.ACORN_AST_TYPES.EXPRESSION_STATEMENT);
        for (const { expression } of functionCalls) {
            const reference = extractCallExpressionInfo(expression);
            if (reference !== null)
                functionReferences.push(reference);
        }
    }
    return functionReferences;
}
// @TODO tobbit refaktoralni, hogy ne regexes szutyok legyen es akkor nem ez kell hanem a findAstFieldReferences
function getFieldFunctionAstMatches(astExpression) {
    const references = findAstFunctionCalls(astExpression);
    return references.map(({ functionName, functionArguments }) => [functionName, ...functionArguments]);
}
// @TODO tobbit refaktoralni, hogy ne regexes szutyok legyen es akkor nem ez kell hanem a findAstFieldReferences
function getFieldFunctionAstMatch(astExpression) {
    const references = findAstFunctionCalls(astExpression);
    return references.reduce((matches, { functionName, functionArguments }) => {
        matches.push(`${functionName}('${functionArguments[0]}', '${functionArguments[1] || 'value'}'`);
        return matches;
    }, []);
}
function replaceInString(str, start, end, replacement) {
    return str.slice(0, start) + replacement + str.slice(end);
}
//# sourceMappingURL=traverser.js.map